import React from 'react';
import RegisterForm from '../components/auth/RegisterForm';

const Register = () => {
  return (
    <div className="flex items-center justify-center min-h-[calc(100vh-12rem)]">
      <RegisterForm />
    </div>
  );
};

export default Register;